import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { URL_TRIPS_OVERVIEW } from '../../router/constants';
import useAnalytics from '../../hooks/useAnalytics';
import { PERMISSION_RIDES } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import EcoDriveSubpage from '../../components/Graphs/EcoDrive/EcoDriveSubpage';

export const Route = createFileRoute('/_authenticated/overview_tours/eco_drive/$vehicleId/$rideId')(
  {
    beforeLoad: async ({ context }) => {
      await requirePermission(PERMISSION_RIDES, ['read'], '/unauthorized', context);
      return {
        ...context,
        documentTitle: {
          main: 'rides.ecoScore',
          suffix: 'menu.overviewTours',
        },
        // Full-screen eco-drive subpage: override the navigator inherited from the
        // overview_tours parent layout and hide the menu.
        isNavigatorEnabled: false,
        isMenuDisabled: true,
      };
    },
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    component: EcoDriveRoute,
  }
);

function EcoDriveRoute() {
  const navigate = useNavigate();
  const { vehicleId, rideId } = Route.useParams();
  const { trackEvent } = useAnalytics();

  const handleClose = useCallback(() => {
    navigate({ to: URL_TRIPS_OVERVIEW });
    trackEvent(['ecoDrive', 'click', 'Trips overview Ecodrive close']);
  }, [navigate, trackEvent]);

  return (
    <EcoDriveSubpage closeCallback={handleClose} vehicleId={Number(vehicleId)} rideId={rideId} />
  );
}
